import axios from "axios";
import { BASE_URL } from "../config";

const getAuthHeaders = () => {
  const token =
    localStorage.getItem("authentication/token") ||
    localStorage.getItem("auth_token") ||
    localStorage.getItem("token") ||
    "";

  return token
    ? {
        Authorization: `Bearer ${token}`,
      }
    : {};
};

export const getDetailedPaymentReport = (params) =>
  axios.get(`${BASE_URL}/provider-payment/dpr`, {
    params,
    headers: getAuthHeaders(),
  });

export const getDetailedPaymentReportAll = (params) =>
  axios.get(`${BASE_URL}/provider-payment/dpr-all`, {
    params,
    headers: getAuthHeaders(),
  });

export const exportDetailedPaymentReportCsv = (params) =>
  axios.get(`${BASE_URL}/provider-payment/dpr/csv`, {
    params,
    headers: getAuthHeaders(),
    responseType: "blob",
  });

export const exportDetailedPaymentReportAllCsv = (params) =>
  axios.get(`${BASE_URL}/provider-payment/dpr-all/csv`, {
    params,
    headers: getAuthHeaders(),
    responseType: "blob",
  });

export const uploadDetailedPaymentReportValidation = (formData) =>
  axios.post(`${BASE_URL}/provider-payment/dpr/validation-upload`, formData, {
    headers: {
      ...getAuthHeaders(),
      "Content-Type": "multipart/form-data",
    },
  });

export const getDprDocuments = (params) =>
  axios.get(`${BASE_URL}/provider-payment/dpr/documents`, {
    params,
    headers: getAuthHeaders(),
  });

export const refreshDprDocumentUrl = (uploadId) =>
  axios.post(
    `${BASE_URL}/provider-payment/dpr/document-refresh-url`,
    { upload_id: uploadId },
    { headers: getAuthHeaders() }
  );
